import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import InfoPage from './components/InfoPage';
import PhotographsPage from './components/PhotographsPage';
import MotherhoodStoryPage from './components/MotherhoodStoryPage';
import MadonnaChildPage from './components/MadonnaChildPage';
import NotesPage from './components/NotesPage';
import PromiseNeverForgetPage from './components/PromiseNeverForgetPage';
import BodyNotThingPage from './components/BodyNotThingPage';
import AnchorPage from './components/AnchorPage';
import WritingPage from './components/WritingPage';
import GiovannittiPage from './components/GiovannittiPage';
import BooksPage from './components/BooksPage';
import ContactPage from './components/ContactPage';
import WorkshopsPage from './components/WorkshopsPage';
import StayInTouchPage from './components/StayInTouchPage';
import QuarryPage from './components/QuarryPage';
import WinterPracticeWorkshopPage from './components/WinterPracticeWorkshopPage';
import SaturdayCritiqueGroupPage from './components/SaturdayCritiqueGroupPage';
import PrintsPage from './components/PrintsPage';
import PortfolioPage from './components/PortfolioPage';
import { useRandomLinkColors } from './utils/useRandomLinkColors';
const AppContent = () => {
  // Apply random colors to all links on mobile
  useRandomLinkColors();
  // Set document title for all pages
  useEffect(() => {
    document.title = 'Madeleine Morlet';
  }, []);
  return <Routes data-id="element-0">
      <Route path="/" element={<HomePage data-id="element-2" />} data-id="element-1" />
      <Route path="/info" element={<InfoPage data-id="element-4" />} data-id="element-3" />
      <Route path="/photographs" element={<PhotographsPage data-id="element-6" />} data-id="element-5" />
      <Route path="/motherhood-story" element={<MotherhoodStoryPage data-id="element-8" />} data-id="element-7" />
      <Route path="/madonna-child" element={<MadonnaChildPage data-id="element-10" />} data-id="element-9" />
      <Route path="/promise-never-forget" element={<PromiseNeverForgetPage data-id="element-12" />} data-id="element-11" />
      <Route path="/body-not-thing" element={<BodyNotThingPage data-id="element-14" />} data-id="element-13" />
      <Route path="/notes" element={<NotesPage data-id="element-16" />} data-id="element-15" />
      <Route path="/anchor" element={<AnchorPage data-id="element-18" />} data-id="element-17" />
      <Route path="/writing" element={<WritingPage data-id="element-20" />} data-id="element-19" />
      <Route path="/giovannitti-needs-god" element={<GiovannittiPage data-id="element-22" />} data-id="element-21" />
      <Route path="/books" element={<BooksPage data-id="element-24" />} data-id="element-23" />
      <Route path="/workshops" element={<WorkshopsPage data-id="element-26" />} data-id="element-25" />
      <Route path="/contact" element={<ContactPage data-id="element-28" />} data-id="element-27" />
      <Route path="/stay-in-touch" element={<StayInTouchPage data-id="element-30" />} data-id="element-29" />
      <Route path="/quarry" element={<QuarryPage data-id="element-32" />} data-id="element-31" />
      <Route path="/winter-practice-workshop" element={<WinterPracticeWorkshopPage data-id="element-34" />} data-id="element-33" />
      <Route path="/saturday-critique-group" element={<SaturdayCritiqueGroupPage data-id="element-36" />} data-id="element-35" />
      <Route path="/prints" element={<PrintsPage data-id="element-38" />} data-id="element-37" />
      <Route path="/portfolio" element={<PortfolioPage data-id="element-40" />} data-id="element-39" />
    </Routes>;
};
export function App() {
  return <Router data-id="element-41">
      <AppContent data-id="element-42" />
    </Router>;
}